import { useDataProviderRoot } from "src/mtska-frontend-data-provider";
import { useDrawer } from "../components";


export const useRelationshipDiscoverer = (params, item, stack) => {
    const { actives } = useDrawer()
    const { discover:dataProviderDiscover } = useDataProviderRoot();

    const discover = (fullKey) => {
        if (!fullKey || typeof fullKey !== 'string') return null;
    
        const keys = fullKey.split('.');
        const rootKey = keys[0];
        let result = null;
        let source = null;

        // cerca rootKey in params
        if (params && params[rootKey] !== undefined) {
            result = params[rootKey];
            source = 'params';
        } 
        
        // cerca rootKey in item
        if (item && item[rootKey] !== undefined && !result) {
            result = item[rootKey];
            source = 'item';
        } 
        
        // cerca rootKey in stack
        if (stack && !result) {
            const found = stack.find(obj => Object.keys(obj)[0] === rootKey);
            if (found) {
                result = found[rootKey];
                source = 'stack';
            }
        }

        // cerca rootKey in actives
        const validDrawerRoutes = [rootKey+'s/detail'];//, rootKey+'s/create']; <--- create non ha params.id, inutile cercarlo
        if (actives && actives.find(obj => obj && validDrawerRoutes.includes(obj.routeName))) {
            const active = actives.find(obj => obj && validDrawerRoutes.includes(obj.routeName));
            const id = active?.params?.id ?? null;

            result = dataProviderDiscover(id);
            source = 'actives';
        } 

        if (!result) return null;
        //console.info('---- trovato', rootKey, 'in', source, result);

        // 2. naviga ricorsivamente le chiavi rimanenti
        for (let i = 1; i < keys.length; i++) {
            if (result && typeof result === 'object' && !Array.isArray(result)) {
                // caso pietoso di person.employment
                if (fullKey == 'person.employment') {
                    let parent = result;
                    result = result[keys[i]];
                    result = { ...result, person: { _id: parent._id, firstname: parent.firstname, lastname: parent.lastname } }
                } else {
                    result = result[keys[i]];
                }
            } else if (result && Array.isArray(result)) {
                // cerca il primo elemento che contiene la chiave richiesta
                const match = result.find(entry => typeof entry === 'object' && entry && keys[i] in entry);
                result = match ? match[keys[i]] : null;
            } else {
                return null;
            }
        }

        return result;
    };

    const discoverInStack = (key) => {
        return stack?.find(obj => Object.keys(obj)[0] === key)?.[key] ?? null;
    }

    const discoverAssignedModelForService = () => {
        if (discover('person.employment') ?? discover('employment')) return 'employee';
        if (discover('car')) return 'car';
        if (discover('contract')) return 'contract';
    }

    return {
        discover,
        discoverInStack,
        discoverAssignedModelForService
    }

};
